/* eslint-disable import/prefer-default-export */
/* eslint-disable react/prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';
import { useLocalizedFromContext } from 'data/Localization';

export const GradientCrop15 = ({ title, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="84.469"
    height="74.636"
    viewBox="0 0 84.469 74.636"
    {...props}
  >
    <title>{useLocalizedFromContext(title)}</title>
    <defs>
      <clipPath id="clip-path15">
        <path
          id="Path_363"
          dataname="Path 363"
          d="M1954.738,26.243a11.755,11.755,0,0,0-9.241-2.81,23.641,23.641,0,0,0-3.956-7.862c-3.446-4.38-10.767-11.2-21.084-7.69a9.844,9.844,0,0,0-5.3,3.946c-5.572-1.074-12.074.368-14.945,6.123a13.391,13.391,0,0,0-1.42,6.329,16.509,16.509,0,0,0-1.66-.407c-5.972-1.116-10.862-.23-14.534,2.633-3.606,2.813-5.786,7.519-6.136,13.253-.6,9.876,2.458,16,5.135,19.407,2.782,3.534,8.086,8.661,15.454,8.66a16.806,16.806,0,0,0,3.838-.466,14.483,14.483,0,0,0,4.621,8.7c3.787,3.5,9.609,5.485,15.492,5.485a25.132,25.132,0,0,0,5.068-.509c11.408-2.357,18.624-8.414,21.2-17.635,8.758-2.345,13.583-8.761,13.583-18.08C1960.859,40.236,1960.064,30.993,1954.738,26.243Zm-37.5-12a.283.283,0,0,0,.016-.031l.013-.023a6.648,6.648,0,0,1,4.159-3.467c8.141-2.772,14.149,2.118,17.76,6.705a20.524,20.524,0,0,1,3.4,6.713,14.891,14.891,0,0,0-8.847,13.371,15.539,15.539,0,0,0-2.638-.448c-2.54-.215-3.247-1.233-4.417-2.92a12.751,12.751,0,0,0-7.943-5.812,1.481,1.481,0,0,0-.056-.927C1916.4,21.7,1915.9,17.15,1917.236,14.242ZM1902.9,19.29c2.279-4.566,7.434-5.123,11.025-4.619-.891,3.372-.332,7.727,1.647,12.974-.469-.072-.956-.138-1.468-.195a21.006,21.006,0,0,0-11.27,1.452A11.372,11.372,0,0,1,1902.9,19.29Zm10.871,11.141c7.241.805,8.868,3.152,10.442,5.421,1.257,1.812,2.682,3.866,6.63,4.2,6.049.512,6.335,3.979,6.343,4.076,0,.5-.019.992-.055,1.468a14.388,14.388,0,0,0-7.272,2.691c-2.375,1.968-2.382,1.966-6.973,1.815-1.281-.042-2.871-.1-4.905-.115h-.218a20.142,20.142,0,0,0-2.358.15c-1.884-1.413-5.69-4.832-6.426-8.132a1.5,1.5,0,1,0-2.927.652c.75,3.365,3.545,6.41,5.645,8.3a17.128,17.128,0,0,0-5.49,3.015,19.331,19.331,0,0,1-5.942-7.451c-2.1-4.529-2.049-8.861.129-11.884C1902.84,31.236,1907.59,29.743,1913.771,30.431ZM1900.845,62.8h0c-.064.509-.088,1.006-.109,1.5-7.635,2.069-13.313-2.588-16.777-6.988-2.354-2.992-5.045-8.434-4.5-17.368.3-4.862,2.069-8.794,4.987-11.07,2.963-2.312,7.042-3,12.138-2.05a11.866,11.866,0,0,1,2.674.816,16.485,16.485,0,0,0,1,2.852,12,12,0,0,0-2.3,2.391c-2.828,3.927-2.98,9.356-.417,14.9a22.329,22.329,0,0,0,6.506,8.314A13.454,13.454,0,0,0,1900.845,62.8Zm44.434-5.413c-.771,11.191-7.437,18.16-19.811,20.716-6.517,1.343-13.714-.359-17.918-4.242a11.8,11.8,0,0,1-3.729-10.689h0c.447-3.571,4.992-10.182,13.945-10.182h.184c2.005.02,3.574.072,4.836.114,4.859.158,5.737.19,8.987-2.5,1.682-1.392,6.856-3.131,10.341-1.344C1944.5,50.476,1945.566,53.211,1945.279,57.383ZM1948,60.038c.119-.8.212-1.611.269-2.448.315-4.557-.836-7.37-2.363-9.114.842-7.85-3.609-11.419-3.8-11.571a1.5,1.5,0,0,0-1.847,2.365c.127.1,2.712,2.253,2.768,7.108a10.118,10.118,0,0,0-2.887-.767c.032-.5.052-1.007.047-1.54a6.862,6.862,0,0,0-3.543-5.355,1.444,1.444,0,0,0,.053-.374c0-7.7,5.685-11.55,8.728-11.9a8.865,8.865,0,0,1,7.318,2.039c4.619,4.12,5.118,13.149,5.118,16.84C1957.859,50.556,1956.095,57.2,1948,60.038Zm-11.632-4.18a1.5,1.5,0,0,1-.241,2.108,16.047,16.047,0,0,1-10.019,3.784,9.749,9.749,0,0,1-2.422-.264,1.5,1.5,0,0,1,.794-2.894c.214.058,4.622,1.125,9.78-2.975A1.5,1.5,0,0,1,1936.37,55.858Zm-12.94-38.423a1.5,1.5,0,0,1,1.228-1.729,10.312,10.312,0,0,1,9.64,4.5,1.5,1.5,0,1,1-2.422,1.77,7.339,7.339,0,0,0-6.718-3.315A1.505,1.505,0,0,1,1923.43,17.435Z"
          fill="none"
        />
      </clipPath>
    </defs>
    <g id="Group_152" dataname="Group 152" transform="translate(-1876.39 -6.91)">
      <g id="Group_151" dataname="Group 151" clipPath="url(#clip-path15)">
        <g id="Group_150" dataname="Group 150">
          <rect
            id="Rectangle_17"
            dataname="Rectangle 17"
            width="191.462"
            height="38.461"
            transform="translate(1829.817 84.818) rotate(-13.203)"
            fill="#5f9501"
          />
          <rect
            id="Rectangle_18"
            dataname="Rectangle 18"
            width="191.462"
            height="38.461"
            transform="translate(1821.032 47.374) rotate(-13.203)"
            fill="#79b61d"
          />
          <rect
            id="Rectangle_19"
            dataname="Rectangle 19"
            width="191.462"
            height="38.461"
            transform="translate(1812.248 9.929) rotate(-13.203)"
            fill="#c8d200"
          />
        </g>
      </g>
    </g>
  </svg>
);

GradientCrop15.defaultProps = {
  title: 'faba_beans',
};

GradientCrop15.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
};
